// tslint:disable:max-line-length
import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from 'primeng/fileupload';
import {TreeTableModule} from 'primeng/treetable';
import { HighchartsChartModule } from 'highcharts-angular';

import { MatIconModule, MatButtonModule, MatCardModule, MatMenuModule, MatTabsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, MatSelectModule, MatBadgeModule, MatCheckboxModule, MatPaginatorModule, MatTableModule, MatSortModule, MatProgressSpinnerModule, MatChipsModule } from '@angular/material';

import { E5coreAngularServicesModule } from 'e5core-angular-services';
import { E5coreAngularUiGetNextComponent } from './components/e5core-ui-get-next/e5core-ui-get-next.component';

import { E5coreUiWorkMenuItemComponent } from './components/e5core-ui-work-menu-item/e5core-ui-work-menu-item.component';
import { E5coreUiWorkMenuItemBoxComponent } from './components/e5core-ui-work-menu-item/component/e5core-ui-work-menu-item-box.component';
import { E5coreUiWorkMenuItemMaterialComponent } from './components/e5core-ui-work-menu-item/component/e5core-ui-work-menu-item-material.component';
import { E5coreUiWorkMenuItemBootstrapComponent } from './components/e5core-ui-work-menu-item/component/e5core-ui-work-menu-item-bootstrap.component';

import { E5CoreUiWorkMenuBoxComponent } from './components/e5core-ui-work-menu/component/e5core-ui-work-menu-box.component';
import { E5CoreUiWorkMenuBootstrapComponent } from './components/e5core-ui-work-menu/component/e5core-ui-work-menu-bootstrap.component';
import { E5CoreUiWorkMenuMaterialComponent } from './components/e5core-ui-work-menu/component/e5core-ui-work-menu-material.component';
import { E5coreUiWorkMenuComponent } from './components/e5core-ui-work-menu/e5core-ui-work-menu.component';
import { E5coreUiWorkItemComponent } from './components/e5core-ui-work-item/e5core-ui-work-item.component';
import { E5coreUiWorkTabComponent } from './components/e5core-ui-work-tab/e5core-ui-work-tab.component';
import { E5coreUiWorkFieldSetComponent } from './components/e5core-ui-work-field-set/e5core-ui-work-field-set.component';
import { E5coreUiWorkFieldComponent } from './components/e5core-ui-work-field/e5core-ui-work-field.component';
import { E5coreUiWorkTabSetComponent } from './components/e5core-ui-work-tab-set/e5core-ui-work-tab-set.component';
import { E5coreUiWorkAttachmentsComponent } from './components/e5core-ui-work-attachments/e5core-ui-work-attachments.component';
import { E5coreUiWorkAttachmentsMaterialComponent } from './components/e5core-ui-work-attachments/component/e5core-ui-work-attachments-material.component';
import { E5coreUiWorkFieldTypeInputComponent } from './components/e5core-ui-work-field-type-input/e5core-ui-work-field-type-input.component';
import { E5coreUiWorkFieldTypeIntegerComponent } from './components/e5core-ui-work-field-type-integer/e5core-ui-work-field-type-integer.component';
import { E5CoreUiWorkItemBoxComponent } from './components/e5core-ui-work-item/component/e5-core-ui-work-item-box.component';
import { E5CoreUiWorkItemBootstrapComponent } from './components/e5core-ui-work-item/component/e5-core-ui-work-item-bootstrap.component';
import { E5CoreUiWorkItemMaterialComponent } from './components/e5core-ui-work-item/component/e5-core-ui-work-item-material.component';
import { E5coreUiWorkTabSetMaterialComponent } from './components/e5core-ui-work-tab-set/component/e5core-ui-work-tab-set-material.component';
import { E5coreUiWorkTabSetBoxComponent } from './components/e5core-ui-work-tab-set/component/e5core-ui-work-tab-set-box.component';
import { E5coreUiWorkTabSetBootstrapComponent } from './components/e5core-ui-work-tab-set/component/e5core-ui-work-tab-set-bootstrap.component';
import { E5coreUiWorkTabBootstrapComponent } from './components/e5core-ui-work-tab/component/e5core-ui-work-tab-bootstrap.component';
import { E5coreUiWorkTabBoxComponent } from './components/e5core-ui-work-tab/component/e5core-ui-work-tab-box.component';
import { E5coreUiWorkTabMaterialComponent } from './components/e5core-ui-work-tab/component/e5core-ui-work-tab-material.component';
import { E5coreUiWorkFieldSetBoxComponent } from './components/e5core-ui-work-field-set/component/e5core-ui-work-field-set-box.component';
import { E5coreUiWorkFieldSetMaterialComponent } from './components/e5core-ui-work-field-set/component/e5core-ui-work-field-set-material.component';
import { E5coreUiWorkFieldSetBootstrapComponent } from './components/e5core-ui-work-field-set/component/e5core-ui-work-field-set-bootstrap.component';
import { E5coreUiWorkFieldBootstrapComponent } from './components/e5core-ui-work-field/component/e5core-ui-work-field-bootstrap.component';
import { E5coreUiWorkFieldMaterialComponent } from './components/e5core-ui-work-field/component/e5core-ui-work-field-material.component';
import { E5coreUiWorkFieldBoxComponent } from './components/e5core-ui-work-field/component/e5core-ui-work-field-box.component';
import { E5coreUiWorkFieldTypeInputBoxComponent } from './components/e5core-ui-work-field-type-input/component/e5core-ui-work-field-type-input-box.component';
import { E5coreUiWorkFieldTypeInputMaterialComponent } from './components/e5core-ui-work-field-type-input/component/e5core-ui-work-field-type-input-material.component';
import { E5coreUiWorkFieldTypeInputBootstrapComponent } from './components/e5core-ui-work-field-type-input/component/e5core-ui-work-field-type-input-bootstrap.component';
import { E5coreUiWorkFieldTypeIntegerBootstrapComponent } from './components/e5core-ui-work-field-type-integer/component/e5core-ui-work-field-type-integer-bootstrap.component';
import { E5coreUiWorkFieldTypeIntegerMaterialComponent } from './components/e5core-ui-work-field-type-integer/component/e5core-ui-work-field-type-integer-material.component';
import { E5coreUiWorkFieldTypeIntegerBoxComponent } from './components/e5core-ui-work-field-type-integer/component/e5core-ui-work-field-type-integer-box.component';
import { E5coreUiWorkFieldTypeDateComponent } from './components/e5core-ui-work-field-type-date/e5core-ui-work-field-type-date.component';
import { E5coreUiWorkFieldTypeDateBoxComponent } from './components/e5core-ui-work-field-type-date/component/e5core-ui-work-field-type-date-box.component';
import { E5coreUiWorkFieldTypeDateMaterialComponent } from './components/e5core-ui-work-field-type-date/component/e5core-ui-work-field-type-date-material.component';
import { E5coreUiWorkFieldTypeDateBootstrapComponent } from './components/e5core-ui-work-field-type-date/component/e5core-ui-work-field-type-date-bootstrap.component';
import { E5coreUiWorkFieldTypeTextComponent } from './components/e5core-ui-work-field-type-text/e5core-ui-work-field-type-text.component';
import { E5coreUiWorkFieldTypeTextBoxComponent } from './components/e5core-ui-work-field-type-text/component/e5core-ui-work-field-type-text-box.component';
import { E5coreUiWorkFieldTypeTextMaterialComponent } from './components/e5core-ui-work-field-type-text/component/e5core-ui-work-field-type-text-material.component';
import { E5coreUiWorkFieldTypeTextBootstrapComponent } from './components/e5core-ui-work-field-type-text/component/e5core-ui-work-field-type-text-bootstrap.component';
import { E5coreUiWorkFieldTypeUserComponent } from './components/e5core-ui-work-field-type-user/e5core-ui-work-field-type-user.component';
import { E5coreUiWorkFieldTypeUserBoxComponent } from './components/e5core-ui-work-field-type-user/component/e5core-ui-work-field-type-user-box.component';
import { E5coreUiWorkFieldTypeUserMaterialComponent } from './components/e5core-ui-work-field-type-user/component/e5core-ui-work-field-type-user-material.component';
import { E5coreUiWorkFieldTypeUserBootstrapComponent } from './components/e5core-ui-work-field-type-user/component/e5core-ui-work-field-type-user-bootstrap.component';
import { E5coreUiWorkFieldSwitchComponent } from './components/e5core-ui-work-field/component/e5core-ui-work-field-switch.component';
import { E5coreUiWorkFieldTypeCheckboxComponent } from './components/e5core-ui-work-field-type-checkbox/e5core-ui-work-field-type-checkbox.component';
import { E5coreUiWorkFieldTypeCheckboxBoxComponent } from './components/e5core-ui-work-field-type-checkbox/component/e5core-ui-work-field-type-checkbox-box.component';
import { E5coreUiWorkFieldTypeCheckboxBootstrapComponent } from './components/e5core-ui-work-field-type-checkbox/component/e5core-ui-work-field-type-checkbox-bootstrap.component';
import { E5coreUiWorkFieldTypeCheckboxMaterialComponent } from './components/e5core-ui-work-field-type-checkbox/component/e5core-ui-work-field-type-checkbox-material.component';
import { E5coreUiWorkFieldTypeListComponent } from './components/e5core-ui-work-field-type-list/e5core-ui-work-field-type-list.component';
import { E5coreUiWorkFieldTypeListMaterialComponent } from './components/e5core-ui-work-field-type-list/component/e5core-ui-work-field-type-list-material.component';
import { E5coreUiWorkFieldTypeListBoxComponent } from './components/e5core-ui-work-field-type-list/component/e5core-ui-work-field-type-list-box.component';
import { E5coreUiWorkFieldTypeListBootstrapComponent } from './components/e5core-ui-work-field-type-list/component/e5core-ui-work-field-type-list-bootstrap.component';
import { E5coreUiWorkFieldTypeCurrencyComponent } from './components/e5core-ui-work-field-type-currency/e5core-ui-work-field-type-currency.component';
import { E5coreUiWorkFieldTypeCurrencyBootstrapComponent } from './components/e5core-ui-work-field-type-currency/component/e5core-ui-work-field-type-currency-bootstrap.component';
import { E5coreUiWorkFieldTypeCurrencyBoxComponent } from './components/e5core-ui-work-field-type-currency/component/e5core-ui-work-field-type-currency-box.component';
import { E5coreUiWorkFieldTypeCurrencyMaterialComponent } from './components/e5core-ui-work-field-type-currency/component/e5core-ui-work-field-type-currency-material.component';
import { E5coreUiWorkHistoryComponent } from './components/e5core-ui-work-history/e5core-ui-work-history.component';
import { E5coreUiWorkHistoryMaterialComponent } from './components/e5core-ui-work-history/component/e5core-ui-work-history-material.component';
import { E5coreUiWorkHistoryBoxComponent } from './components/e5core-ui-work-history/component/e5core-ui-work-history-box.component';
import { E5coreUiWorkHistoryBootstrapComponent } from './components/e5core-ui-work-history/component/e5core-ui-work-history-bootstrap.component';
import { E5coreUiWorkCasenotesComponent } from './components/e5core-ui-work-casenotes/e5core-ui-work-casenotes.component';
import { E5coreUiWorkCasenotesBootstrapComponent } from './components/e5core-ui-work-casenotes/component/e5core-ui-work-casenotes-bootstrap.component';
import { E5coreUiWorkCasenotesMaterialComponent } from './components/e5core-ui-work-casenotes/component/e5core-ui-work-casenotes-material.component';
import { E5coreUiWorkCasenotesBoxComponent } from './components/e5core-ui-work-casenotes/component/e5core-ui-work-casenotes-box.component';
import { E5coreUiSearchFormComponent } from './components/e5core-ui-search-form/e5core-ui-search-form.component';
import { E5coreUiSearchFormBootstrapComponent } from './components/e5core-ui-search-form/component/e5core-ui-search-form-bootstrap.component';
import { E5coreUiSearchFormMaterialComponent } from './components/e5core-ui-search-form/component/e5core-ui-search-form-material.component';
import { E5coreUiSearchFormBoxComponent } from './components/e5core-ui-search-form/component/e5core-ui-search-form-box.component';
import { E5coreUiSearchResultsComponent } from './components/e5core-ui-search-results/e5core-ui-search-results.component';
import { E5coreUiSearchResultsBootstrapComponent } from './components/e5core-ui-search-results/component/e5core-ui-search-results-bootstrap.component';
import { E5coreUiSearchResultsMaterialComponent } from './components/e5core-ui-search-results/component/e5core-ui-search-results-material.component';
import { E5coreUiSearchResultsBoxComponent } from './components/e5core-ui-search-results/component/e5core-ui-search-results-box.component';
import { E5coreUiSearchMenuComponent } from './components/e5core-ui-search-menu/e5core-ui-search-menu.component';
import { E5coreUiSearchMenuBootstrapComponent } from './components/e5core-ui-search-menu/component/e5core-ui-search-menu-bootstrap.component';
import { E5coreUiSearchMenuBoxComponent } from './components/e5core-ui-search-menu/component/e5core-ui-search-menu-box.component';
import { E5coreUiSearchMenuMaterialComponent } from './components/e5core-ui-search-menu/component/e5core-ui-search-menu-material.component';
import { E5coreUiFileUploadComponent } from './components/e5core-ui-file-upload/e5core-ui-file-upload.component';
import { E5coreUiFileUploadPrimeComponent } from './components/e5core-ui-file-upload/component/e5core-ui-file-upload-prime.component';
import { E5coreUiGenerateDocumentComponent } from './components/e5core-ui-generate-document/e5core-ui-generate-document.component';
import { E5coreUiGenerateDocumentMaterialComponent } from './components/e5core-ui-generate-document/component/e5core-ui-generate-document-material.component';
import { E5coreUiSafePipe } from './util/e5core-ui-safe.pipe';
import { E5coreUiCategorizationComponent } from './components/e5core-ui-categorization/e5core-ui-categorization.component';
import { E5coreUiCategorizationBootstrapComponent } from './components/e5core-ui-categorization/component/e5core-ui-categorization-bootstrap.component';
import { E5coreUiCategorizationBoxComponent } from './components/e5core-ui-categorization/component/e5core-ui-categorization-box.component';
import { E5coreUiCategorizationMaterialComponent } from './components/e5core-ui-categorization/component/e5core-ui-categorization-material.component';
import { E5coreUiGenerateDocumentBoxComponent } from './components/e5core-ui-generate-document/component/e5core-ui-generate-document-box.component';
import { E5coreUiGenerateDocumentBootstrapComponent } from './components/e5core-ui-generate-document/component/e5core-ui-generate-document-bootstrap.component';
import { E5coreUiWorkAttachmentViewerComponent } from './components/e5core-ui-work-attachment-viewer/e5core-ui-work-attachment-viewer.component';
import { E5coreUiWebdavWeburiAttachmentViewerComponent } from './components/e5core-ui-work-attachment-viewer/component/e5core-ui-webdav-weburi-attachment-viewer.component';
import { E5coreUiE5AttachmentViewerComponent } from './components/e5core-ui-work-attachment-viewer/component/e5core-ui-e5-attachment-viewer.component';
import { E5coreUiWeburiAttachmentViewerComponent } from './components/e5core-ui-work-attachment-viewer/component/e5core-ui-weburi-attachment-viewer.component';
import { E5coreUiConversationViewerComponent } from './components/e5core-ui-conversation-viewer/e5core-ui-conversation-viewer.component';
import { E5coreUiEmailConversationViewerComponent } from './components/e5core-ui-conversation-viewer/component/e5core-ui-email-conversation-viewer.component';
import { E5coreUiSelectFromListComponent } from './components/e5core-ui-select-from-list/e5core-ui-select-from-list.component';
import { E5coreUiSelectFromListMaterialComponent } from './components/e5core-ui-select-from-list/component/e5core-ui-select-from-list-material.component';
import { E5coreUiWorkRelatedItemsComponent } from './components/e5core-ui-work-related-items/e5core-ui-work-related-items.component';
import { E5coreUiWorkRelatedItemsPrimeComponent } from './components/e5core-ui-work-related-items/component/e5core-ui-work-related-items-prime.component';
import { E5coreUiAssignUserBootstrapComponent } from './components/e5core-ui-work-assign-user/component/e5core-ui-work-assign-user-bootstrap.component';
import { E5coreUiAssignUserBoxComponent } from './components/e5core-ui-work-assign-user/component/e5core-ui-work-assign-user-box.component';
import { E5coreUiAssignUserMaterialComponent } from './components/e5core-ui-work-assign-user/component/e5core-ui-work-assign-user-material.component';
import { E5coreUiAssignUserComponent } from './components/e5core-ui-work-assign-user/e5core-ui-work-assign-user.component';
import { E5coreUiMonitorSlaComponent } from './components/e5core-ui-monitor-sla/e5core-ui-monitor-sla.component';
import { E5coreUiMonitorSlaHighchartsComponent } from './components/e5core-ui-monitor-sla/component/e5core-ui-monitor-sla-highcharts.component';
import { E5coreUiDatagridComponent } from './components/e5core-ui-datagrid/e5core-ui-datagrid.component';
import { E5coreUiDatagridBootstrapComponent } from './components/e5core-ui-datagrid/component/e5core-ui-datagrid-bootstrap.component';
import { E5coreUiDatagridMaterialComponent } from './components/e5core-ui-datagrid/component/e5core-ui-datagrid-material.component';
import { E5coreUiDatagridBoxComponent } from './components/e5core-ui-datagrid/component/e5core-ui-datagrid-box.component';
import { E5coreUiMonitorSlaCompletionHighchartsComponent } from './components/e5core-ui-monitor-sla-completion/component/e5core-ui-monitor-sla-completion-highcharts.component';
import { E5coreUiMonitorSlaCompletionComponent } from './components/e5core-ui-monitor-sla-completion/e5core-ui-monitor-sla-completion.component';
import { E5coreUiMonitorSlaInflowsComponent } from './components/e5core-ui-monitor-sla-inflows/e5core-ui-monitor-sla-inflows.component';
import { E5coreUiMonitorSlaInflowsHighchartsComponent } from './components/e5core-ui-monitor-sla-inflows/component/e5core-ui-monitor-sla-inflows-highcharts.component';
import { E5coreUiMonitorSlaInventoryComponent } from './components/e5core-ui-monitor-sla-inventory/e5core-ui-monitor-sla-inventory.component';
import { E5coreUiMonitorSlaInventoryHighchartsComponent } from './components/e5core-ui-monitor-sla-inventory/component/e5core-ui-monitor-sla-inventory-highcharts.component';
import { E5coreUiMonitorSlaTeamProductivityComponent } from './components/e5core-ui-monitor-sla-team-productivity/team-productivity.component';
import { E5coreUiMonitorSlaTeamProductivityHighchartsComponent } from './components/e5core-ui-monitor-sla-team-productivity/component/highcharts.component';
import { E5coreUiWorkDiariseComponent } from './components/e5core-ui-work-diarise/e5core-ui-work-diarise.component';
import { E5coreUiDatepickerComponent } from './components/e5core-ui-datepicker/e5core-ui-datepicker.component';
import { E5coreUiWorkDiariseMaterialComponent } from './components/e5core-ui-work-diarise/component/e5core-ui-work-diarise-material.component';
import { E5coreUiTimepickerComponent } from './components/e5core-ui-timepicker/e5core-ui-timepicker.component';
import { E5coreUiTimepickerMaterialComponent } from './components/e5core-ui-timepicker/component/e5core-ui-timepicker-material.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // BrowserAnimationsModule,
    E5coreAngularServicesModule,
    // Material
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatBadgeModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    FileUploadModule,
    HighchartsChartModule,
    TreeTableModule,
    NgxMaterialTimepickerModule
  ],
  declarations: [
    E5coreAngularUiGetNextComponent,
    E5coreUiWorkItemComponent,
    E5coreUiWorkMenuComponent,
    E5coreUiWorkTabComponent,
    E5coreUiWorkFieldSetComponent,
    E5coreUiWorkFieldComponent,
    E5coreUiWorkHistoryComponent,
    E5coreUiWorkTabSetComponent,
    E5coreUiWorkAttachmentsComponent,
    E5coreUiWorkAttachmentsMaterialComponent,
    E5coreUiWorkMenuItemComponent,
    E5coreUiWorkFieldTypeInputComponent,
    E5coreUiWorkFieldTypeIntegerComponent,
    E5CoreUiWorkItemBoxComponent,
    E5CoreUiWorkItemBootstrapComponent,
    E5CoreUiWorkItemMaterialComponent,
    E5CoreUiWorkMenuMaterialComponent,
    E5CoreUiWorkMenuBootstrapComponent,
    E5CoreUiWorkMenuBoxComponent,
    E5coreUiWorkMenuItemBoxComponent,
    E5coreUiWorkMenuItemMaterialComponent,
    E5coreUiWorkMenuItemBootstrapComponent,
    E5coreUiWorkTabSetMaterialComponent,
    E5coreUiWorkTabSetBoxComponent,
    E5coreUiWorkTabSetBootstrapComponent,
    E5coreUiWorkTabBootstrapComponent,
    E5coreUiWorkTabBoxComponent,
    E5coreUiWorkTabMaterialComponent,
    E5coreUiWorkFieldSetBoxComponent,
    E5coreUiWorkFieldSetMaterialComponent,
    E5coreUiWorkFieldSetBootstrapComponent,
    E5coreUiWorkFieldBootstrapComponent,
    E5coreUiWorkFieldMaterialComponent,
    E5coreUiWorkFieldBoxComponent,
    E5coreUiWorkFieldTypeInputBoxComponent,
    E5coreUiWorkFieldTypeInputMaterialComponent,
    E5coreUiWorkFieldTypeInputBootstrapComponent,
    E5coreUiWorkFieldTypeIntegerBootstrapComponent,
    E5coreUiWorkFieldTypeIntegerMaterialComponent,
    E5coreUiWorkFieldTypeIntegerBoxComponent,
    E5coreUiWorkFieldTypeDateComponent,
    E5coreUiWorkFieldTypeDateBoxComponent,
    E5coreUiWorkFieldTypeDateMaterialComponent,
    E5coreUiWorkFieldTypeDateBootstrapComponent,
    E5coreUiWorkFieldTypeTextComponent,
    E5coreUiWorkFieldTypeTextBoxComponent,
    E5coreUiWorkFieldTypeTextMaterialComponent,
    E5coreUiWorkFieldTypeTextBootstrapComponent,
    E5coreUiWorkFieldTypeUserComponent,
    E5coreUiWorkFieldTypeUserBoxComponent,
    E5coreUiWorkFieldTypeUserMaterialComponent,
    E5coreUiWorkFieldTypeUserBootstrapComponent,
    E5coreUiWorkFieldSwitchComponent,
    E5coreUiWorkFieldTypeCheckboxComponent,
    E5coreUiWorkFieldTypeCheckboxBoxComponent,
    E5coreUiWorkFieldTypeCheckboxBootstrapComponent,
    E5coreUiWorkFieldTypeCheckboxMaterialComponent,
    E5coreUiWorkFieldTypeListComponent,
    E5coreUiWorkFieldTypeListMaterialComponent,
    E5coreUiWorkFieldTypeListBoxComponent,
    E5coreUiWorkFieldTypeListBootstrapComponent,
    E5coreUiWorkFieldTypeCurrencyComponent,
    E5coreUiWorkFieldTypeCurrencyBootstrapComponent,
    E5coreUiWorkFieldTypeCurrencyBoxComponent,
    E5coreUiWorkFieldTypeCurrencyMaterialComponent,
    E5coreUiWorkHistoryComponent,
    E5coreUiWorkHistoryMaterialComponent,
    E5coreUiWorkHistoryBoxComponent,
    E5coreUiWorkHistoryBootstrapComponent,
    E5coreUiWorkCasenotesComponent,
    E5coreUiWorkCasenotesBootstrapComponent,
    E5coreUiWorkCasenotesMaterialComponent,
    E5coreUiWorkCasenotesBoxComponent,
    E5coreUiWorkDiariseComponent,
    E5coreUiSearchFormComponent,
    E5coreUiSearchFormBootstrapComponent,
    E5coreUiSearchFormMaterialComponent,
    E5coreUiSearchFormBoxComponent,
    E5coreUiSearchResultsComponent,
    E5coreUiSearchResultsBootstrapComponent,
    E5coreUiSearchResultsMaterialComponent,
    E5coreUiSearchResultsBoxComponent,
    E5coreUiSearchMenuComponent,
    E5coreUiSearchMenuBootstrapComponent,
    E5coreUiSearchMenuMaterialComponent,
    E5coreUiSearchMenuBoxComponent,
    E5coreUiFileUploadComponent,
    E5coreUiFileUploadPrimeComponent,
    E5coreUiGenerateDocumentComponent,
    E5coreUiGenerateDocumentMaterialComponent,
    E5coreUiGenerateDocumentBoxComponent,
    E5coreUiGenerateDocumentBootstrapComponent,
    E5coreUiWorkAttachmentViewerComponent,
    E5coreUiE5AttachmentViewerComponent,
    E5coreUiWeburiAttachmentViewerComponent,
    E5coreUiWebdavWeburiAttachmentViewerComponent,
    E5coreUiConversationViewerComponent,
    E5coreUiEmailConversationViewerComponent,
    E5coreUiAssignUserComponent,
    E5coreUiAssignUserMaterialComponent,
    E5coreUiAssignUserBoxComponent,
    E5coreUiAssignUserBootstrapComponent,
    E5coreUiSelectFromListComponent,
    E5coreUiSelectFromListMaterialComponent,
    E5coreUiWorkRelatedItemsComponent,
    E5coreUiWorkRelatedItemsPrimeComponent,
    E5coreUiSafePipe,
    E5coreUiCategorizationComponent,
    E5coreUiCategorizationBootstrapComponent,
    E5coreUiCategorizationBoxComponent,
    E5coreUiCategorizationMaterialComponent,
    E5coreUiMonitorSlaHighchartsComponent,
    E5coreUiMonitorSlaComponent,
    E5coreUiDatagridComponent,
    E5coreUiDatagridBootstrapComponent,
    E5coreUiDatagridMaterialComponent,
    E5coreUiDatagridBoxComponent,
    E5coreUiWorkDiariseComponent,
    E5coreUiDatepickerComponent,
    E5coreUiWorkDiariseMaterialComponent,
    E5coreUiWorkDiariseComponent,
    E5coreUiTimepickerComponent,
    E5coreUiTimepickerMaterialComponent,
    E5coreUiMonitorSlaComponent,
    E5coreUiMonitorSlaCompletionComponent,
    E5coreUiMonitorSlaCompletionHighchartsComponent,
    E5coreUiMonitorSlaInflowsComponent,
    E5coreUiMonitorSlaInflowsHighchartsComponent,
    E5coreUiMonitorSlaInventoryComponent,
    E5coreUiMonitorSlaInventoryHighchartsComponent,
    E5coreUiMonitorSlaTeamProductivityComponent,
    E5coreUiMonitorSlaTeamProductivityHighchartsComponent
  ],
  exports: [
    E5coreAngularUiGetNextComponent,
    E5coreUiWorkMenuComponent,
    E5coreUiWorkItemComponent,
    E5coreUiWorkTabSetComponent,
    E5coreUiWorkFieldSetComponent,
    E5coreUiWorkHistoryComponent,
    E5coreUiWorkCasenotesComponent,
    E5coreUiWorkDiariseComponent,
    E5coreUiSearchResultsComponent,
    E5coreUiSearchFormComponent,
    E5coreUiSearchMenuComponent,
    E5coreUiFileUploadComponent,
    E5coreUiWorkAttachmentsComponent,
    E5coreUiGenerateDocumentComponent,
    E5coreUiWorkAttachmentViewerComponent,
    E5coreUiConversationViewerComponent,
    E5coreUiAssignUserComponent,
    E5coreUiSelectFromListComponent,
    E5coreUiWorkRelatedItemsComponent,
    E5coreUiCategorizationComponent,
    E5coreUiMonitorSlaComponent,
    E5coreUiDatepickerComponent,
    E5coreUiMonitorSlaCompletionComponent,
    E5coreUiMonitorSlaCompletionHighchartsComponent,
    E5coreUiMonitorSlaInflowsComponent,
    E5coreUiMonitorSlaInflowsHighchartsComponent,
    E5coreUiMonitorSlaInventoryComponent,
    E5coreUiMonitorSlaInventoryHighchartsComponent,
    E5coreUiMonitorSlaTeamProductivityComponent,
    E5coreUiMonitorSlaTeamProductivityHighchartsComponent
  ],
  providers: [
    CurrencyPipe,
    DatePipe
  ]
})
export class E5coreAngularUiModule { }
